import { authHeader } from '@/services/auth'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    existingImmatriculation: false,
    loadingStatus: false
  },
  getters: {
    getExistingImmatriculation (state) {
      return state.existingImmatriculation
    },
    getLoadingStatus (state) {
      return state.loadingStatus
    }
  },
  mutations: {
    setExistingImmatriculation (state, existingImmatriculation) {
      state.existingImmatriculation = existingImmatriculation
    },
    setLoadingStatus(state, loadingStatus) {
      state.loadingStatus = loadingStatus
    }
  },
  actions: {
    checkCurrentImmatriculation ({ commit, getters }, payload) {
      commit('setExistingImmatriculation', false)
      const params = {
        headers: authHeader()
      }
      let valueResponse = false
      return HTTP_HYPER_ESPACE_BACKEND.get('/annonce?dataValues[NUMERO_IMMATRICULATION]=' + payload, params)
        .then(response => {
          if(response.data.total_items > 0) {
            valueResponse = true
          }
          else {
            valueResponse = false
          }
          let returnResponse = {
            object: response.data,
            id: null
          }
          if(response.data._embedded.annonce[0]) {
            returnResponse.id = response.data._embedded.annonce[0].id
          }
          return returnResponse
        })
        .catch(error => {
          return { type: 'error', message: error }
        })
        .finally(response => {
          commit('setExistingImmatriculation', valueResponse)
          return response
        })
    }
  }
}
